import { doc, getDoc } from "firebase/firestore";

/**
 * If the profile builder is running redirect the user to the profile builder page
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Skip middleware on server
  if (import.meta.server) return;

  if (to.path.includes("/profile-builder")) {
    return;
  }
  if (from.path.includes("/verify-email")) {
    return;
  }

  // Check current user
  const db = useFirestore();
  const user = useCurrentUser();

  // If no user is logged in, don't proceed with the check
  if (!user.value?.uid) return;

  const userId = user.value?.uid;

  // Check if profile builder is running
  const checkProfileBuilderStatus = async () => {
    try {
      const ref = doc(db, "personadata", userId, "Status", "CurrentState");

      const document = await getDoc(ref);

      if (document.exists()) {
        const data = document.data();

        console.log("🔒 Profile builder status", data);

        const isLoading = data?.loading === true;

        if (isLoading) {
          console.log(
            "🔒 Profile builder Redirect",
            "From",
            from.path,
            "To",
            to.path
          );
          return navigateTo("/profile-loading");
        }
      }
    } catch (error) {
      console.error("Error checking profile builder status:", error);
    }
  };

  // Execute the check
  checkProfileBuilderStatus();
});
